module.exports = __webpack_public_path__ + "img/a323e31592437dfbb4d13ece9370c37.f7066720.jpg";